import * as React from "react";
import type { SVGProps } from "react";
export const SvgArrowLineRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="m14.829 12.172-4.244 4.243L9.173 15 12 12.172 9.17 9.344l1.415-1.415z" />
  </svg>
);
